import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCN from '@/locales/zh-CN.json'
import errors from '@/locales/errors.json'

Vue.use(VueI18n)

export default new VueI18n({
  locale: 'zh-CN',
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': {
      ...zhCN,
      errors,
    },
  },
})
